import { useState, FormEvent } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d6nvd9eancq2eie81l60', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', company: '', email: '', phone: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <section id="contact" className="bg-black py-16 sm:py-24 lg:py-32">
      <div className="container mx-auto px-4 sm:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Border frame */}
          <div className="border-2 border-yellow-600 p-6 sm:p-10 lg:p-16">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-16 lg:gap-20">
              {/* Left - Information */}
              <div>
                <h2 className="text-white text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 sm:mb-8">
                  CONTACT ARK CAPITAL™
                </h2>
                <div className="w-20 h-0.5 bg-yellow-600 mb-8 sm:mb-12"></div>

                <div className="space-y-6 sm:space-y-8">
                  <div>
                    <div className="text-yellow-600 text-xs tracking-[0.2em] uppercase mb-2">
                      Headquarters
                    </div>
                    <div className="text-white/85 text-sm sm:text-base">
                      Global Investment Operations
                    </div>
                  </div>

                  <div>
                    <div className="text-yellow-600 text-xs tracking-[0.2em] uppercase mb-2">
                      Address
                    </div>
                    <div className="text-white/85 text-sm sm:text-base leading-relaxed">
                      PO Box 91133<br />
                      Bexley, OH 43209
                    </div>
                  </div>

                  <div>
                    <div className="text-yellow-600 text-xs tracking-[0.2em] uppercase mb-2">
                      Investor Relations
                    </div>
                    <div className="text-white/85 text-sm sm:text-base break-all">
                      investors@arkcapitalgroup.net
                    </div>
                  </div>

                  <div>
                    <div className="text-yellow-600 text-xs tracking-[0.2em] uppercase mb-2">
                      Partnerships
                    </div>
                    <div className="text-white/85 text-sm sm:text-base break-all">
                      partnerships@arkcapitalgroup.net
                    </div>
                  </div>

                  <div>
                    <div className="text-yellow-600 text-xs tracking-[0.2em] uppercase mb-2">
                      Phone
                    </div>
                    <a href="tel:6143014667" className="text-white/85 text-sm sm:text-base hover:text-yellow-600 transition-colors duration-300">
                      614-301-4667
                    </a>
                  </div>
                </div>

                <div className="mt-8 sm:mt-12">
                  <div className="flex items-center gap-3">
                    <a href="#" className="inline-flex items-center justify-center w-10 h-10 border border-yellow-600 text-yellow-600 hover:bg-yellow-600 hover:text-black transition-all duration-300 cursor-pointer">
                      <i className="ri-linkedin-fill text-xl"></i>
                    </a>
                    <a href="#" className="inline-flex items-center justify-center w-10 h-10 border border-yellow-600 text-yellow-600 hover:bg-yellow-600 hover:text-black transition-all duration-300 cursor-pointer">
                      <i className="ri-twitter-x-fill text-xl"></i>
                    </a>
                    <a href="#" className="inline-flex items-center justify-center w-10 h-10 border border-yellow-600 text-yellow-600 hover:bg-yellow-600 hover:text-black transition-all duration-300 cursor-pointer">
                      <i className="ri-instagram-fill text-xl"></i>
                    </a>
                    <a href="#" className="inline-flex items-center justify-center w-10 h-10 border border-yellow-600 text-yellow-600 hover:bg-yellow-600 hover:text-black transition-all duration-300 cursor-pointer">
                      <i className="ri-facebook-fill text-xl"></i>
                    </a>
                  </div>
                </div>
              </div>

              {/* Right - Form */}
              <div>
                <form onSubmit={handleSubmit} data-readdy-form id="contact-form">
                  <div className="space-y-6 sm:space-y-8">
                    <div>
                      <label className="text-yellow-600 text-[11px] tracking-[0.2em] uppercase block mb-2">Name</label>
                      <input type="text" name="name" value={formData.name} onChange={handleChange} required
                        className="w-full bg-transparent border-b border-yellow-600 text-white text-sm py-3 focus:outline-none focus:border-b-2 transition-all" />
                    </div>
                    <div>
                      <label className="text-yellow-600 text-[11px] tracking-[0.2em] uppercase block mb-2">Company</label>
                      <input type="text" name="company" value={formData.company} onChange={handleChange} required
                        className="w-full bg-transparent border-b border-yellow-600 text-white text-sm py-3 focus:outline-none focus:border-b-2 transition-all" />
                    </div>
                    <div>
                      <label className="text-yellow-600 text-[11px] tracking-[0.2em] uppercase block mb-2">Email</label>
                      <input type="email" name="email" value={formData.email} onChange={handleChange} required
                        className="w-full bg-transparent border-b border-yellow-600 text-white text-sm py-3 focus:outline-none focus:border-b-2 transition-all" />
                    </div>
                    <div>
                      <label className="text-yellow-600 text-[11px] tracking-[0.2em] uppercase block mb-2">Phone</label>
                      <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required
                        className="w-full bg-transparent border-b border-yellow-600 text-white text-sm py-3 focus:outline-none focus:border-b-2 transition-all" />
                    </div>
                    <div>
                      <label className="text-yellow-600 text-[11px] tracking-[0.2em] uppercase block mb-2">Message</label>
                      <textarea name="message" value={formData.message} onChange={handleChange} required maxLength={500} rows={4}
                        className="w-full bg-transparent border-b border-yellow-600 text-white text-sm py-3 focus:outline-none focus:border-b-2 transition-all resize-none"></textarea>
                      <div className="text-white/50 text-xs mt-1 text-right">{formData.message.length}/500</div>
                    </div>
                    <button type="submit" disabled={isSubmitting}
                      className="w-full bg-yellow-600 text-black py-4 sm:py-5 font-semibold tracking-wide hover:bg-yellow-500 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap text-sm">
                      {isSubmitting ? 'SUBMITTING...' : 'SUBMIT INQUIRY'}
                    </button>
                    {submitStatus === 'success' && (
                      <div className="text-green-500 text-sm text-center">Thank you for your inquiry. We will contact you shortly.</div>
                    )}
                    {submitStatus === 'error' && (
                      <div className="text-red-500 text-sm text-center">An error occurred. Please try again.</div>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}